/* eslint-disable default-param-last */

import { Reducer } from 'redux';
import produce from 'immer';
import { ActivitiesState, ActivitiesTypes } from './types';

const INITIAL_STATE_REQUEST = { loading: false, loaded: false, error: false };
const INITIAL_STATE: ActivitiesState = {
  activities: {},
  request: {
    fetch_activities: INITIAL_STATE_REQUEST,
  },
};

const reducer: Reducer<ActivitiesState> = (state = INITIAL_STATE, { type, result }) => {
  return produce(state, (draft) => {
    switch (type) {
      case ActivitiesTypes.FETCH_ACTIVITIES_REQUEST:
        draft.request.fetch_activities = {
          ...INITIAL_STATE_REQUEST,
          loading: true,
        };
        break;

      case ActivitiesTypes.FETCH_ACTIVITIES_SUCCESS:
        draft.activities = result.data;
        draft.request.fetch_activities = {
          ...INITIAL_STATE_REQUEST,
          loaded: true,
        };
        break;

      case ActivitiesTypes.FETCH_ACTIVITIES_FAILURE:
        draft.request.fetch_activities = {
          ...INITIAL_STATE_REQUEST,
          error: true,
        };
        break;

      case 'ZERA_ATIVIDADES':
        draft.activities = {};
        break;

      default:
    }
  });
};
export default reducer;
